import { useLiveQuery } from 'dexie-react-hooks';
import { db } from '../infrastructure/dexie-queue';

/**
 * Live count of queued operations (set updates + session ops) waiting to
 * flush. Re-renders automatically when either Dexie table changes — covers
 * the case where a finish/cancel queued offline and the user's looking at
 * the SyncIndicator badge for confirmation.
 */
export function usePendingSyncCount(): number {
  const count = useLiveQuery(
    async () => {
      const [sets, sessions] = await Promise.all([
        db.pendingSetUpdates.count(),
        db.pendingSessionOps.count(),
      ]);
      return sets + sessions;
    },
    [],
    0,
  );
  return count;
}
